import { FLAGS, useFlag } from '@iheartjane/feature-flags';

import { useManager } from '@jane/business-admin/data-access';

export const useIsFulfillmentV2Enabled = (): boolean => {
  const { data: managerData } = useManager();
  const flag = useFlag(FLAGS.c1FulfillmentV2);
  return flag || !!managerData?.manager?.internal;
};
